var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 412,
    viewBox: "0 0 394 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0116 42.9234C127.412 19.0025 146.612 7.04206 167.655 2.71483C178.75 0.433371 190.112 -0.265777 201.403 0.638197C222.818 2.35276 243.339 11.8689 284.383 30.9013C324.299 52.1964 344.257 62.8439 358.526 78.9044C366.049 87.372 372.336 96.8621 377.198 107.092C386.421 126.495 388.44 149.026 392.48 194.087C393.996 239.303 394.754 261.91 387.979 282.298C384.408 293.047 379.332 303.236 372.904 312.563C360.712 330.251 342.21 343.265 305.206 369.294C266.805 393.215 247.605 405.175 226.562 409.502C215.467 411.784 204.105 412.483 192.815 411.579C171.399 409.864 150.878 400.348 109.835 381.316C69.9183 360.021 49.9602 349.373 35.6911 333.313C28.1679 324.845 21.8815 315.355 17.019 305.125C7.79629 285.722 5.77671 263.191 1.73756 218.131C0.221559 172.915 -0.536442 150.307 6.23772 129.919C9.80928 119.17 14.8847 108.981 21.313 99.6547C33.5054 81.966 52.0075 68.9518 89.0116 42.9234Z",
    fill: "#FFCD23"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon3);
export default __webpack_public_path__ + "static/media/hexagon3.696510e4e20893a8b4ed83ba93fbcbff.svg";
export { ForwardRef as ReactComponent };